import { render, staticRenderFns } from "./noticeAdd.vue?vue&type=template&id=0ec79bca&scoped=true"
import script from "./noticeAdd.vue?vue&type=script&lang=js"
export * from "./noticeAdd.vue?vue&type=script&lang=js"
import style0 from "./noticeAdd.vue?vue&type=style&index=0&id=0ec79bca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec79bca",
  null
  
)

export default component.exports